import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { AirlineEditorData } from "../../state/Airlines/EditorData";


const updateAirlinesEditorData: Reducer<AirlineEditorData> = (state: AirlineEditorData = new AirlineEditorData(), action: Action<ActionType, AirlineEditorData>) => {
  switch (action.type) {
    case ActionType.AIRLINES_EDITOR_DATA_RESET:
      return new AirlineEditorData();
    case ActionType.AIRLINES_EDITOR_DATA_FETCHED:
      return { ...state, airlineData: action.data };
    case ActionType.AIRLINES_EDITOR_DATA_COPIED:
      return { ...state, airlineData: { ...action.data} };
    case ActionType.AIRLINES_EDITOR_DATA_UPDATED:
      return { ...state, airlineData: { ...state.airlineData, ...action.data } };
    case ActionType.AIRLINES_EDITOR_DATA_SAVED:
      return { ...state, readyToSave: false };
    case ActionType.AIRLINES_EDITOR_DATA_VALIDATED:
      return { ...state, validation: action.data };
    default:
      return state;
  }
};

export default updateAirlinesEditorData;